import { render, staticRenderFns } from "./UserBackgroundController.vue?vue&type=template&id=f01efcbe&"
import script from "./UserBackgroundController.vue?vue&type=script&lang=ts&"
export * from "./UserBackgroundController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports